import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import msgConstants from '../../constants/msgConstants'
import { loadingReset, loadingUpdate } from '../../store/actions/loadingAction'
import notaFiscalManager from '../../services/api/notaFiscal/notaFiscalManager'
import { RegraNotaFiscal } from '../../types/notaFiscalApiTypes'

export function regraNotaFiscalIO() {
  const { parceiroId, regraId } = useParams<{ parceiroId: string; regraId: string }>()
  const [regraNotaFiscalEditar, setRegraNotaFiscalEditar] = useState<RegraNotaFiscal>()
  const dispatch = useDispatch()

  useEffect(() => {
    if (!regraId) {
      dispatch(loadingReset())
      return
    }

    dispatch(loadingUpdate(true))
    notaFiscalManager
      .buscarRegra(parceiroId, regraId)
      .then((response: RegraNotaFiscal) => {
        setRegraNotaFiscalEditar(response)
      })
      .catch(() => toast.error(msgConstants.USO_GENERICO.erroBusca))
      .finally(() => {
        dispatch(loadingReset())
      })
  }, [dispatch, parceiroId, regraId])

  return {
    regraNotaFiscalEditar,
    regraId
  }
}

export type RegraNotaFiscalIO = ReturnType<typeof regraNotaFiscalIO>
